var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLaunchpad = function SvgLaunchpad(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#launchpad_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.625 8.45a12.5 12.5 0 0 1 1.75-2.196c3.428-3.428 8.314-4.402 12.25-2.818 1.584 3.937.61 8.822-2.817 12.25-.681.68-1.42 1.265-2.196 1.75l.151 2.572a.476.476 0 0 1-.36.49L10.99 21.6a.476.476 0 0 1-.592-.462v-3.037c0-.253-.1-.495-.28-.674l-3.484-3.484a.95.95 0 0 0-.673-.28H2.922a.476.476 0 0 1-.462-.591l1.104-4.415a.476.476 0 0 1 .49-.36zm6.467 2.52a1.906 1.906 0 1 0 2.694-2.695 1.906 1.906 0 0 0-2.694 2.695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.938 14.625 4.719 4.718c-1.508.62-3.884 1.294-5.392.674-.62-1.508.053-3.884.673-5.392"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "launchpad_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgLaunchpad;